// CardSection.js
import React from 'react';
// import { connect } from 'react-redux';
import { CardNumberElement, CardExpiryElement, CardCVCElement, PostalCodeElement } from 'react-stripe-elements';
import './CardSection.scss';

const FIELDS = ['cardNumber', 'cardExpiry', 'cardCvc'];
class CardSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      cardNumber: '',
      cardExpiry: '',
      // postalCode: '',
      cardCvc: ''
    };
  }

  hasAllValues = () => {
    let hasValue = true;
    FIELDS.map((field) => {
      hasValue = hasValue ? (this.state[field] ? true : false) : hasValue
      return null
    })
    return hasValue
  }

  cardValuechange = (event) => {
    let newState = Object.assign({}, this.state)
    let { errors } = newState;
    errors[event.elementType] = event.error ? event.error.message : ''
    newState[event.elementType] = event.complete
    newState.errors = errors
    this.setState(newState)
    this.props.updateErrors(errors, this.hasAllValues())
  }


  render() {
    let { errors } = this.state;
    // let { scholarship } = this.props;

    var labelConfig = {
      color: '',
    }

    return (
      <div className="stripe-payment-gateway-card-field-section">

        <div className="section group">
          <div className="col span_12_of_12">
            <label class="CTAGrey" for="amount">Card Number <span className='add-red-asterisk'>*</span></label>
            <CardNumberElement placeholder="Card Number" style={{ base: { fontFamily: 'Inter-Medium', fontSize: "18px", fontWeight: "400", fontStretch: "normal", fontStyle: "normal" } }} onChange={this.cardValuechange} className="input-card-number" />
            <div className="error visible">{errors['cardNumber']}</div>
          </div>
        </div>

        <div className="section group">
          <div className="col span_8_of_12">
            <label class="CTAGrey" for="amount">Card Expiry <span className='add-red-asterisk'>*</span></label>
            <CardExpiryElement style={{ base: { fontFamily: 'Inter-Medium', fontSize: "18px", fontWeight: "400", fontStretch: "normal", fontStyle: "normal" } }} onChange={this.cardValuechange} className="input-card-expiry" />
            <div className="error visible">{errors['cardExpiry']}</div>
          </div>

          <div className="col span_4_of_12">
            <label class="CTAGrey" for="amount">Card CVC <span className='add-red-asterisk'>*</span></label>
            <CardCVCElement style={{ base: { fontFamily: 'Inter-Medium', fontSize: "18px", fontWeight: "400", fontStretch: "normal", fontStyle: "normal" } }} onChange={this.cardValuechange} className="input-card-cvc"  />
            <div className="error visible">{errors['cardCvc']}</div>
          </div>
        </div>

      </div>
    );
  }
}

// const mapStateToProps = (state) => {
//   return {
//     scholarship: state.scholarship,
//   };
// };

// export default connect(mapStateToProps, null)(CardSection);
export default CardSection;